module.exports = __webpack_public_path__ + "img/clipboard-black.942b34e3.svg";